var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMintingInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2703 8.26758L22.6003 16.7098C22.846 16.9455 22.9841 17.2653 22.9841 17.5988C22.9841 17.9322 22.846 18.252 22.6003 18.4877L21.6743 19.3757C21.4291 19.6118 21.0961 19.7445 20.7488 19.7445C20.4015 19.7445 20.0685 19.6118 19.8233 19.3757L11.0293 10.4237",
    stroke: "#8D9D91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.57911 8.23143C6.69227 6.57289 9.25846 4.10935 10.9861 1.12071C11.2313 0.884636 11.5643 0.751953 11.9116 0.751953C12.2589 0.751953 12.5919 0.884636 12.8371 1.12071L16.3471 4.49031C16.593 4.72572 16.7312 5.0454 16.7312 5.37879C16.7312 5.71218 16.593 6.03187 16.3471 6.26727C13.2027 7.88572 10.626 10.3594 8.94011 13.378C8.69459 13.6139 8.36147 13.7464 8.01411 13.7464C7.66674 13.7464 7.33362 13.6139 7.08811 13.378L3.57911 10.0094C3.33338 9.77366 3.19531 9.45386 3.19531 9.12039C3.19531 8.78692 3.33338 8.46713 3.57911 8.23143Z",
    stroke: "#8D9D91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 20.8795V20.8795C12.75 20.0842 12.0784 19.4395 11.25 19.4395H3.75C2.92157 19.4395 2.25 20.0842 2.25 20.8795V20.8795V22.3195H12.75V20.8795Z",
    stroke: "#8D9D91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 22.3203H14.25",
    stroke: "#8D9D91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMintingInactive);
export default __webpack_public_path__ + "static/media/minting-Inactive.88d22d52c571a3d6609793cc00d6f54e.svg";
export { ForwardRef as ReactComponent };